<template>
  <div class="container block_screen">
    <div class="">
      <div class="first_page">
        <div class="container--small">
          <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
          <p class="promo-text">
            Willkommen zum
          </p>
          <h1>Daten/Betriebssystem migrieren</h1>
          <p class="desc">
            &nbsp;
          </p>
          <ul class="hdm_list">
            <li><a @click.prevent="changeScreen(54)" class="tellus gotolast" href="#">Festplatte kopieren</a></li>
            <li><a @click.prevent="changeScreen(58)" class="tellus gotolast" href="#">Betriebssystem kopieren</a></li>
          </ul>
          <br>
          <p class="desc">
            Wählen Sie ein Szenario und schauen Sie, welche Lösung Festplatten Manager bereit hält!
            <br>
          </p>
          <br>
          <br>
          <br>
          <br>
          <div class="btn_right">
            <a href="" @click.prevent="changeScreen(100)"
               class="btn btn_orange">Überspringen</a>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_left">
      <a href="" @click.prevent="changeScreen(0)"
         class="btn btn_orange">Zurück</a>
    </div>
  </div>
</template>
<script>
  import {mapMutations} from 'vuex'
  export default {
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
